import React from 'react'
import Skeleton from 'react-loading-skeleton'
import CustomSlider from 'components/Slider'

const MobileCategorySliderSkeleton = () => {
  const categoryCount = 5

  return (
    <div className="flex items-end -mt-7 gap-2 p-[10px]">
      <div className="bg-gray-200 p-[12px] rounded-full w-10 h-10 mb-[2px] flex items-center justify-center">
        <Skeleton width={16} height={16} />
      </div>
      <div className="brands-slider">
        <CustomSlider
          style={{
            display: 'flex !important',
            justifyContent: 'space-between',
          }}
          settings={{
            dots: false,
            swipeToSlide: true,
            slidesToShow: 5,
            autoplay: false,
          }}
        >
          {Array(categoryCount)
            .fill()
            .map((_, index) => (
              <div key={index} className="px-1">
                <div className="flex items-center justify-center w-11 h-11 sm:w-24 bg-[#f7fafc] rounded-full">
                  <Skeleton width={20} height={20} />
                </div>
              </div>
            ))}
        </CustomSlider>
      </div>
    </div>
  )
}

export default MobileCategorySliderSkeleton
